import { ApiActionType } from 'api/volops';
import { IconName } from 'components/Icon/IconName';

type Args = {
  listingType:
    | 'JOB'
    | 'GRAD_PROGRAM'
    | 'INTERNSHIP'
    | 'VOLOP'
    | 'IMPORTED'
    | 'ORG';
  actionType: ApiActionType | undefined;
};

export function getListingTypeLabelIcon({
  listingType,
  actionType,
}: Args): IconName {
  switch (listingType) {
    case 'JOB':
    case 'GRAD_PROGRAM':
      return 'briefcase';
    case 'INTERNSHIP':
      return 'sign-path';

    case 'VOLOP':
    case 'IMPORTED':
      switch (actionType) {
        case 'DONATION':
          return 'coins';
        case 'PETITION':
          return 'clipboard';
        case 'EVENT':
          return 'star-calendar';
        case 'LOAN':
          return 'money';
        default:
          return 'hand';
      }

    case 'ORG':
      return 'building';
  }
}
